import HEAD from '@/components/Head.vue'
import NAVMENU from '@/components/Home.vue';
import TagsView from '@/components/TagsView';
import FButton from '@/components/FButton';
import SearchForm from '@/components/SearchForm';
import SearchFormWrap from '@/components/SearchFormWrap';
import ToolBar from "@/components/TableToolBar/index";
import TButton from "@/components/TableToolBar/TButton";
import FSingleImageUpload from "@/components/FSingleImageUpload";
import FSingleImageWrapper from '@/components/FSingleImageWrapper';
import OperatorSelect from "@/components/PropsSelect/OperatorSelect";
import OperatorSelectById from "@/components/PropsSelect/OperatorSelectById";
import FPanel from '@/components/FPanel';
import AddressPicked from '@/components/AddressPicked';
import OperatorSelectByName from "@/components/PropsSelect/OperatorSelectByName";
import PageWrapper from "@/components/PageWrapper/index";
import Operator from "@/components/operation/Operator";
import SitePoint from "@/components/operation/SitePoint";
import Province from "@/components/AddressSelect/Province";
import City from "@/components/AddressSelect/City";
import Brand from "@/components/operation/Brand";
import Modle from "@/components/operation/Modle";
import MultipleTreeOperator from "@/components/TreeSelect/MultipleTreeOperator";
import OperatorToId from "@/components/operation/OperatorToId";
import OperatorShow from "@/components/OperatorShow";
import MultipleSite from "@/components/operation/MultipleSite"; //可以多选查询的所属租赁点
export default {
  install: function (Vue) {
    Vue.component('public-head', HEAD)
    Vue.component('public-nav', NAVMENU)
    Vue.component('tags-view', TagsView)
    Vue.component('f-button', FButton)
    Vue.component('search-from', SearchForm)
    Vue.component('search-from-wrap', SearchFormWrap)
    Vue.component('tool-bar', ToolBar)
    Vue.component('t-button', TButton)
    Vue.component('f-single-image-upload', FSingleImageUpload)
    Vue.component('f-single-image-wrapper',FSingleImageWrapper)
    // Vue.component('operator-select', OperatorSelect)
    Vue.component('operator-select', OperatorSelectById)
     Vue.component('operator-select-name', OperatorSelectByName)
     Vue.component('page-wrapper',PageWrapper)
     Vue.component("address-picked",AddressPicked)
     Vue.component('f-panel',FPanel)
     Vue.component('operator',Operator)
    Vue.component('OperatorToId',OperatorToId)
     Vue.component('province',Province)
     Vue.component('city',City)
     Vue.component('brand',Brand)
     Vue.component('modle',Modle)
     Vue.component('site-point',SitePoint)
     Vue.component('multiple-tree-operator',MultipleTreeOperator)
     Vue.component('operator-show',OperatorShow)
     Vue.component('multiple-site',MultipleSite) 

  }
}



// WEBPACK FOOTER //
// ./src/components/index.js